export function validateAndFormatLocale(
  unformattedLocale: string,
  supportedLocales: ReadonlyArray<string>,
): string | null {
  const [lang, region] = unformattedLocale.split("-");

  if (!lang || !region) {
    return null;
  }

  const locale = `${lang}-${region.toLocaleUpperCase()}`;

  if (supportedLocales.includes(locale)) {
    return locale;
  } else return null;
}

export default validateAndFormatLocale;
